// @flow
import type {ListingShape} from '../components/Hit/Hit';
import type {PinnedListing} from '../components/HitCollection/HitCollection';

/*
SRS returns pinned listing as a first listing in props.listings array. GTS returns pinned listing as separate listing
not included in props.listings array. To migrate on GTS we transform SRS response to match GTS shape.
To preserve backward compatibility we send separate pinned listing from SRS BUT this listing also will be in props.listings array.

buildListingsCollection conditionally returns array of listings:
    - if pinned listing is present and is the same as first in props.listings array it returns array of pinned listing
      and listings from 2-nd to the end;
    - if pinned listing is present and not equal to first one it returns array of pinned listing and all listings
    - if pinned listing is not present - return only array of listings.
 */
export const mergeListingsCollectionWithPinnedListing = (
    listings: ListingShape[],
    pinnedListingWrapper: ?PinnedListing
): ListingShape[] => {
    const {listing: pinnedListing} = pinnedListingWrapper || {};
    const {listingId: pinnedListingId} = pinnedListing || {};

    const [firstListing, ...restListings] = listings;

    return pinnedListing &&
        firstListing &&
        pinnedListingId === firstListing.listingId
        ? [].concat(pinnedListing, restListings) // return `[].concat(pinnedListing, restListings)` instead of `listing1s` because for pinnedListing we call additional field called `availableForDates`
        : [].concat(pinnedListing || [], listings);
};
